export const CURRENCIES_DECIMAL_PLACES: { [key: string]: number } = {
  BTC: 8,
  BCH: 8,
  ETH: 8,
  WBTC: 8,
  DOGE: 8,
  LTC: 8,
  SHIB: 8,
  APE: 8,
  MATIC: 8,
  GUSD: 2,
  USDC: 2,
  USDP: 2,
  DAI: 2,
  BUSD: 2,
  EUROC: 2,
  USDT: 2,
  // From the provided Stripe information:
  BIF: 0, // Zero-decimal
  CLP: 0,
  DJF: 0,
  GNF: 0,
  JPY: 0,
  KMF: 0,
  KRW: 0,
  MGA: 0,
  PYG: 0,
  RWF: 0,
  UGX: 0,
  VND: 0,
  VUV: 0,
  XAF: 0,
  XOF: 0,
  XPF: 0,
  // Rest of the currencies from the Stripe list:
  USD: 2,
  AED: 2,
  AFN: 2, // Note: '*' currencies from Stripe list were assumed to have 2 decimal places
  ALL: 2,
  AMD: 2,
  ANG: 2,
  AOA: 2,
  ARS: 2,
  AUD: 2,
  AWG: 2,
  AZN: 2,
  BAM: 2,
  BBD: 2,
  BDT: 2,
  BGN: 2,
  BMD: 2,
  BND: 2,
  BOB: 2,
  BRL: 2,
  BSD: 2,
  BWP: 2,
  BYN: 2,
  BZD: 2,
  CAD: 2,
  CDF: 2,
  CHF: 2,
  CNY: 2,
  COP: 2,
  CRC: 2,
  CVE: 2,
  CZK: 2,
  DKK: 2,
  DOP: 2,
  DZD: 2,
  EGP: 2,
  ETB: 2,
  EUR: 2,
  FJD: 2,
  FKP: 2,
  GBP: 2,
  GEL: 2,
  GIP: 2,
  GMD: 2,
  GTQ: 2,
  GYD: 2,
  HKD: 2,
  HNL: 2,
  HTG: 2,
  HUF: 2,
  IDR: 2,
  ILS: 2,
  INR: 2,
  ISK: 2,
  JMD: 2,
  KES: 2,
  KGS: 2,
  KHR: 2,
  KYD: 2,
  KZT: 2,
  LAK: 2,
  LBP: 2,
  LKR: 2,
  LRD: 2,
  LSL: 2,
  MAD: 2,
  MDL: 2,
  MKD: 2,
  MMK: 2,
  MNT: 2,
  MOP: 2,
  MRO: 2,
  MUR: 2,
  MVR: 2,
  MWK: 2,
  MXN: 2,
  MYR: 2,
  MZN: 2,
  NAD: 2,
  NGN: 2,
  NIO: 2,
  NOK: 2,
  NPR: 2,
  NZD: 2,
  PAB: 2,
  PEN: 2,
  PGK: 2,
  PHP: 2,
  PKR: 2,
  PLN: 2,
  QAR: 2,
  RON: 2,
  RSD: 2,
  RUB: 2,
  SAR: 2,
  SBD: 2,
  SCR: 2,
  SEK: 2,
  SGD: 2,
  SHP: 2,
  SLE: 2,
  SOS: 2,
  SRD: 2,
  STD: 2,
  SZL: 2,
  THB: 2,
  TJS: 2,
  TOP: 2,
  TRY: 2,
  TTD: 2,
  TWD: 2,
  TZS: 2,
  UAH: 2,
  UYU: 2,
  WST: 2,
  XCD: 2,
  YER: 2,
  ZAR: 2,
  ZMW: 2,
  ZWL: 2,
  BNB: 6,
  SOL: 6,
  XRP: 6,
  ADA: 6,
  AVAX: 6,
  LINK: 6,
  TRX: 6,
  DOT: 6,
  TON: 6,
};

export const MAP_CURRENCIES_DECIMAL_PLACES: { [key: string]: number } = {
  BTC: 5,
  BCH: 5,
  ETH: 5,
  WBTC: 5,
  DOGE: 5,
  LTC: 5,
  SHIB: 5,
  APE: 5,
  MATIC: 5,
  GUSD: 2,
  USDC: 2,
  USDP: 2,
  DAI: 2,
  BUSD: 2,
  EUROC: 2,
  USDT: 2,
  // From the provided Stripe information:
  BIF: 0, // Zero-decimal
  CLP: 0,
  DJF: 0,
  GNF: 0,
  JPY: 0,
  KMF: 0,
  KRW: 0,
  MGA: 0,
  PYG: 0,
  RWF: 0,
  UGX: 0,
  VND: 0,
  VUV: 0,
  XAF: 0,
  XOF: 0,
  XPF: 0,
  // Rest of the currencies from the Stripe list:
  USD: 2,
  AED: 2,
  AFN: 2, // Note: '*' currencies from Stripe list were assumed to have 2 decimal places
  ALL: 2,
  AMD: 2,
  ANG: 2,
  AOA: 2,
  ARS: 2,
  AUD: 2,
  AWG: 2,
  AZN: 2,
  BAM: 2,
  BBD: 2,
  BDT: 2,
  BGN: 2,
  BMD: 2,
  BND: 2,
  BOB: 2,
  BRL: 2,
  BSD: 2,
  BWP: 2,
  BYN: 2,
  BZD: 2,
  CAD: 2,
  CDF: 2,
  CHF: 2,
  CNY: 2,
  COP: 2,
  CRC: 2,
  CVE: 2,
  CZK: 2,
  DKK: 2,
  DOP: 2,
  DZD: 2,
  EGP: 2,
  ETB: 2,
  EUR: 2,
  FJD: 2,
  FKP: 2,
  GBP: 2,
  GEL: 2,
  GIP: 2,
  GMD: 2,
  GTQ: 2,
  GYD: 2,
  HKD: 2,
  HNL: 2,
  HTG: 2,
  HUF: 2,
  IDR: 2,
  ILS: 2,
  INR: 2,
  ISK: 2,
  JMD: 2,
  KES: 2,
  KGS: 2,
  KHR: 2,
  KYD: 2,
  KZT: 2,
  LAK: 2,
  LBP: 2,
  LKR: 2,
  LRD: 2,
  LSL: 2,
  MAD: 2,
  MDL: 2,
  MKD: 2,
  MMK: 2,
  MNT: 2,
  MOP: 2,
  MRO: 2,
  MUR: 2,
  MVR: 2,
  MWK: 2,
  MXN: 2,
  MYR: 2,
  MZN: 2,
  NAD: 2,
  NGN: 2,
  NIO: 2,
  NOK: 2,
  NPR: 2,
  NZD: 2,
  PAB: 2,
  PEN: 2,
  PGK: 2,
  PHP: 2,
  PKR: 2,
  PLN: 2,
  QAR: 2,
  RON: 2,
  RSD: 2,
  RUB: 2,
  SAR: 2,
  SBD: 2,
  SCR: 2,
  SEK: 2,
  SGD: 2,
  SHP: 2,
  SLE: 2,
  SOS: 2,
  SRD: 2,
  STD: 2,
  SZL: 2,
  THB: 2,
  TJS: 2,
  TOP: 2,
  TRY: 2,
  TTD: 2,
  TWD: 2,
  TZS: 2,
  UAH: 2,
  UYU: 2,
  WST: 2,
  XCD: 2,
  YER: 2,
  ZAR: 2,
  ZMW: 2,
  ZWL: 2,
  BNB: 5,
  SOL: 5,
  XRP: 5,
  ADA: 5,
  AVAX: 5,
  LINK: 5,
  TRX: 5,
  DOT: 5,
  TON: 5,
};

export const ALLOWED_CURRENCIES_CODES = [
  "USD",
  "DOT",
  "UNI",
  "XMR",
  "ETC",
  "XLM",
  "KAS",
  "FDUSD",
  "OKB",
  "AAVE",
  "LINK",
  "FIL",
  "ARB",
  "RUNE",
  "CRO",
  "HBAR",
  "VET",
  "ATOM",
  "GRT",
  "FLOKI",
  "THETA",
  "JASMY",
  "CFX",
  "SUPER",
  "ZEC",
  "FTT",
  "MANA",
  "CHZ",
  "LUNC",
  "CAKE",
  "TUSD",
  "KLAY",
  "XDC",
  "IOTA",
  "BTG",
  "IOTX",
  "TFUEL",
  "ETHW",
  "1INCH",
  "JST",
  "MX",
  "HOT",
  "ZIL",
  "DASH",
  "RVN",
  "GAS",
  "ENJ",
  "BAT",
  "TRX",
  "TON",
  "AVAX",
  "SOL",
  "BNB",
  "DOGE",
  "ADA",
  "USDT",
  "USDC",
  "WBTC",
  "FTM",
  "SEI",
  "OM",
  "ALGO",
  "BSV",
  "BEAM",
  "GT",
  "AXS",
  "USDD",
  "GALA",
  "NEO",
  "EOS",
  "XEC",
  "EGLD",
  "XTZ",
  "SAND",
  "PYUSD",
  "QTUM",
  "LUNA",
  "DCR",
  "USDP",
  "CUSD",
  "XVG",
  "DGB",
  "ZEN",
  "SXP",
  "STPT",
  "ARK",
  "FRONT",
  "FUN",
  "SHIB",
  "NEAR",
  "APT",
  "DGD",
  "MCO",
  "YFI",
  "OCEAN",
  "LSK",
  "ONT",
  "AE",
  "COTI",
  "NPXS",
  "GRS",
  "LGCY",
  "DAO",
  "REP",
  "WAVES",
  "XZC",
  "FIRO",
  "PAX",
  "BCD",
  "WABI",
  "HT",
  "KMD",
  "XNO",
  "STRAX",
  "ICX",
  "XEM",
  "CTSI",
  "ONE",
  "XCUR",
  "VIB",
  "KLV",
  "HOGE",
  "SRK",
  "GUSD",
  "XYM",
  "CHR",
  "NWC",
  "KISHU",
  "KEANU",
  "UST",
  "FEG",
  "KNC",
  "C98",
  "CVC",
  "LEASH",
  "TKO",
  "OMG",
  "CNS",
  "GSPI",
  "SPI",
  "TRVL",
  "RXCG",
  "BABYDOGE",
  "XYO",
  "POODL",
  "BEL",
  "ARPA",
  "FLUF",
  "RACA",
  "KIBA",
  "PIT",
  "NFTB",
  "RBIF",
  "POOLZ",
  "BLOCKS",
  "CUDOS",
  "AVN",
  "MARSH",
  "ILV",
  "ARV",
  "VOLT",
  "CULT",
  "TOMO",
  "GHC",
  "HOTCROSS",
  "PIKA",
  "XCAD",
  "GAFA",
  "BTFA",
  "BTTC",
  "TENSHI",
  "GAL",
  "DGMOON",
  "DOGECOIN",
  "GUARD",
  "GGTKN",
  "QUACK",
  "TTC",
  "BONE",
  "DIVI",
  "TLOS",
  "ONIGI",
  "FITFI",
  "STKK",
  "SPACE-ID",
  "ZBC",
  "GARI",
  "HEX",
  "PIVX",
  "BRG",
  "PLS",
  "EPIC",
  "BRISE",
  "USDJ",
  "SUN",
  "WINTRC20",
  "ATLAS",
  "SYSEVM",
  "POOLX",
  "TUP",
  "XAUT",
  "EURT",
  "VERSE",
  "CSPR",
  "BOBA",
  "BANANA",
  "DINO",
  "PEW",
  "DAI",
  "BUSD",
  "MATIC",
  "XRP",
  "APE",
  "BTC",
  "ETH",
  "BCH",
  "LTC",
  "EUR",
  "GBP",
  "AUD",
  "CAD",
  "SGD",
  "CNY",
  "HKD",
  "JPY",
  "CHF",
  "INR",
  "BRL",
  "RUB",
  "KRW",
  "MXN",
  "ZAR",
  "NZD",
  "NOK",
  "SEK",
  "DKK",
  "TRY",
  "THB",
  "ILS",
  "PLN",
  "MYR",
  "IDR",
  "SAR",
  "AED",
  "TWD",
  "ARS",
  "COP",
  "CLP",
  "HUF",
  "CZK",
  "EGP",
  "UAH",
  "QAR",
  "KWD",
  "RON",
  "BGN",
  "ISK",
  "JOD",
  "OMR",
  "AZN",
  "BHD",
  "XOF",
  "FJD",
  "GEL",
  "KZT",
  "MOP",
  "MDL",
  "NAD",
];

export const ALLOWED_CURRENCIES_CODES_FROM_BITPAY = [
  "EUR",
  "GBP",
  "AUD",
  "CAD",
  "SGD",
  "CNY",
  "HKD",
  "JPY",
  "CHF",
  "INR",
  "BRL",
  "RUB",
  "KRW",
  "MXN",
  "ZAR",
  "NZD",
  "NOK",
  "SEK",
  "DKK",
  "TRY",
  "THB",
  "ILS",
  "PLN",
  "MYR",
  "IDR",
  "SAR",
  "AED",
  "TWD",
  "ARS",
  "COP",
  "CLP",
  "HUF",
  "CZK",
  "EGP",
  "UAH",
  "QAR",
  "KWD",
  "RON",
  "BGN",
  "ISK",
  "JOD",
  "OMR",
  "AZN",
  "BHD",
  "XOF",
  "FJD",
  "GEL",
  "KZT",
  "MOP",
  "MDL",
  "NAD",
];

export const CURRENCY_TO_COUNTRY_CODE: Record<string, string> = {
  EUR: "FR", // France (Eurozone)
  GBP: "GB", // United Kingdom
  AUD: "AU", // Australia
  CAD: "CA", // Canada
  SGD: "SG", // Singapore
  CNY: "CN", // China
  HKD: "HK", // Hong Kong
  JPY: "JP", // Japan
  CHF: "CH", // Switzerland
  INR: "IN", // India
  BRL: "BR", // Brazil
  RUB: "RU", // Russia
  KRW: "KR", // South Korea
  MXN: "MX", // Mexico
  ZAR: "ZA", // South Africa
  NZD: "NZ", // New Zealand
  NOK: "NO", // Norway
  SEK: "SE", // Sweden
  DKK: "DK", // Denmark
  TRY: "TR", // Turkey
  THB: "TH", // Thailand
  ILS: "IL", // Israel
  PLN: "PL", // Poland
  MYR: "MY", // Malaysia
  IDR: "ID", // Indonesia
  SAR: "SA", // Saudi Arabia
  AED: "AE", // United Arab Emirates
  TWD: "TW", // Taiwan
  ARS: "AR", // Argentina
  COP: "CO", // Colombia
  CLP: "CL", // Chile
  HUF: "HU", // Hungary
  CZK: "CZ", // Czech Republic
  EGP: "EG", // Egypt
  UAH: "UA", // Ukraine
  QAR: "QA", // Qatar
  KWD: "KW", // Kuwait
  RON: "RO", // Romania
  BGN: "BG", // Bulgaria
  ISK: "IS", // Iceland
  JOD: "JO", // Jordan
  OMR: "OM", // Oman
  AZN: "AZ", // Azerbaijan
  BHD: "BH", // Bahrain
  XOF: "SN", // Senegal (UEMOA region)
  FJD: "FJ", // Fiji
  GEL: "GE", // Georgia
  KZT: "KZ", // Kazakhstan
  MOP: "MO", // Macau
  MDL: "MD", // Moldova
  NAD: "NA", // Namibia
};

export const COUNTRY_TO_CURRENCY_CODE: Record<string, string> = Object.entries(
  CURRENCY_TO_COUNTRY_CODE
).reduce(
  (acc, [currency, country]) => {
    acc[country] = currency;
    return acc;
  },
  {} as Record<string, string>
);

export const KLARNA_CURRENCIES = [
  "EUR",
  "DKK",
  "GBP",
  "NOK",
  "SEK",
  "CZK",
  "RON",
  "PLN",
  "CHF",
];

export const WECHAT_CURRENCIES = ["EUR", "CHF", "CNY"];

export const ALIPAY_CURRENCIES = ["EUR"];

export const GOOGLEPAY_CURRENCIES = [
  "GBP",
  "USD",
  "BGN",
  "CAD",
  "HRK",
  "EUR",
  "CZK",
  "DKK",
  "HKD",
  "HUF",
  "JPY",
  "CHF",
  "MYR",
  "MXN",
  "NZD",
  "NOK",
  "PLN",
  "RON",
  "SGD",
  "SEK",
  "THB",
  "AED",
  "BRL",
  "AUD",
  "JOD",
  "SKK",
  "KZT",
  "KES",
  "KWD",
  "KGS",
  "LAK",
  "SHP",
  "WST",
  "STD",
  "SAR",
  "RSD",
  "SCR",
  "SLL",
  "SBD",
  "SOS",
  "ZAR",
  "KRW",
  "SSP",
  "LKR",
  "SDG",
  "SRD",
  "SZL",
  "SYP",
  "TJS",
  "TZS",
  "CDF",
  "TOP",
  "TTD",
  "TND",
  "TRY",
  "TMT",
  "UGX",
  "UAH",
  "UYU",
  "UZS",
  "VUV",
  "VEF",
  "VND",
  "YER",
  "ZMW",
  "ZWD",
  "LVL",
  "LBP",
  "LSL",
  "LRD",
  "LYD",
  "LTL",
  "MOP",
  "MKD",
  "MGF",
  "MWK",
  "MVR",
  "MTL",
  "MRO",
  "MUR",
  "MDL",
  "MNT",
  "MAD",
  "MZN",
  "MMR",
  "NAD",
  "NPR",
  "ANG",
  "NIO",
  "NGN",
  "KPW",
  "OMR",
  "PKR",
  "PAB",
  "PGK",
  "PYG",
  "PEN",
  "PHP",
  "QAR",
  "RUB",
  "RWF",
  "JMD",
  "ILS",
  "IQD",
  "IRR",
  "IDR",
  "ISK",
  "HNL",
  "HTG",
  "GYD",
  "CFA",
  "GNF",
  "QTQ",
  "GIP",
  "GHS",
  "GEL",
  "GMD",
  "XPF",
  "FJD",
  "FKP",
  "EEK",
  "ETB",
  "ERN",
  "SVC",
  "EGP",
  "ECS",
  "DOP",
  "DJF",
  "CUP",
  "CRC",
  "KMF",
  "COP",
  "CNY",
  "CYP",
  "CLP",
  "KYD",
  "CVE",
  "XAF",
  "KHR",
  "BIF",
  "BND",
  "BWP",
  "BAM",
  "BOB",
  "BTN",
  "BMD",
  "XOF",
  "BZD",
  "BYR",
  "BBD",
  "BDT",
  "BHD",
  "BSD",
  "AZN",
  "AWG",
  "AMD",
  "ARS",
  "XCD",
  "AOA",
  "DZD",
  "ALL",
  "AFN",
  "INR",
  "FJD",
  "BYN",
  "GTQ",
  "MGA",
  "MMK",
  "SLE",
  "TWD",
  "XCG",
];

export const SLEAP_DEFAULT_CURRENCY_USD = "USD";
